export {
  PdpHero,
  type PdpHeroConfig,
  type PdpHeroDetail,
  type PdpHeroFeature,
  type PdpHeroSlideChange,
  type PdpHeroSocialProof,
} from './PdpHero'
